'use client';

import dynamic from 'next/dynamic';
import type { ComponentProps } from 'react';

// `ssr: false` is only allowed inside Client Components, so the browser-only
// reviews widgets are loaded from this wrapper instead of the server page.
const ReviewsSectionRoot = dynamic(() => import('../ReviewsSection/Root'), {
  ssr: false,
});
const ReviewsSectionHeader = dynamic(() => import('../ReviewsSection/Header'), {
  ssr: false,
});
const ReviewsSectionFilterAndAnchor = dynamic(
  () => import('../ReviewsSection/FilterAndAnchor'),
  {
    ssr: false,
  },
);
const ReviewsSectionList = dynamic(() => import('../ReviewsSection/List'), {
  ssr: false,
});

type ReviewsSectionListProps = ComponentProps<
  (typeof import('../ReviewsSection/List'))['default']
>;

type Props = {
  countReviews: number;
  avgReviews: number;
  productReviews: ReviewsSectionListProps['productReviews'];
  writeReviewHref: string;
};

export default function ExperienceReviewsSection({
  countReviews,
  avgReviews,
  productReviews,
  writeReviewHref,
}: Props) {
  return (
    <ReviewsSectionRoot className="mb-[30px] md:mb-[50px]">
      <ReviewsSectionHeader
        countReviews={countReviews}
        avgReviews={avgReviews}
        className="flex flex-wrap">
        <ReviewsSectionFilterAndAnchor writeReviewHref={writeReviewHref} />
      </ReviewsSectionHeader>
      <ReviewsSectionList
        productReviews={productReviews}
        className="mt-0 p-0 desktop:mt-[45px] desktop:shadow-[0_10px_20px_0_rgba(0,0,0,0.1)]"
        isExperience
      />
    </ReviewsSectionRoot>
  );
}
